import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LuArrowRight, LuCirclePlay } from 'react-icons/lu';
import type { IconType } from 'react-icons';

import SbrIcon from './SbrIcon';

export type HeroCtaBlock = 'home-hero' | 'rg-hero' | 'ind-hero';

export type HeroSecondaryCta = {
  to: string;
  label: string;
  shortLabel?: string;
  variant?: 'outline-light' | 'outline-primary';
  icon?: IconType;
  iconPosition?: 'start' | 'end';
};

type HeroCtaActionsProps = {
  block: HeroCtaBlock;
  outlineVariant?: 'outline-light' | 'outline-primary';
  buttonSize?: 'lg';
  arrowIconSize?: number;
  playIconSize?: number;
  secondaryClassName?: string;
  outlineClassName?: string;
  secondary?: HeroSecondaryCta;
};

const DEFAULT_SECONDARY: HeroSecondaryCta = {
  to: '/how-it-works',
  label: 'See How It Works',
  icon: LuCirclePlay,
  iconPosition: 'start',
};

export default function HeroCtaActions({
  block,
  outlineVariant = 'outline-light',
  buttonSize = 'lg',
  arrowIconSize = 18,
  playIconSize = 18,
  secondaryClassName = 'fw-semibold',
  outlineClassName = 'fw-semibold',
  secondary = DEFAULT_SECONDARY,
}: HeroCtaActionsProps) {
  const btnClass = `${block}__cta-btn`;
  const labelClass = `${block}__cta-label`;
  const iconClass = `${block}__cta-icon`;

  const secondaryVariant = secondary.variant ?? outlineVariant;
  const SecondaryIcon = secondary.icon ?? LuCirclePlay;
  const iconAtStart = (secondary.iconPosition ?? 'start') === 'start';
  const secondaryIconSize = SecondaryIcon === LuCirclePlay ? playIconSize : arrowIconSize;

  const secondaryLabel = secondary.shortLabel ? (
    <>
      <span className={`${labelClass} d-none d-sm-inline`}>{secondary.label}</span>
      <span className={`${labelClass} d-sm-none`}>{secondary.shortLabel}</span>
    </>
  ) : (
    <span className={labelClass}>{secondary.label}</span>
  );

  return (
    <>
      <Button
        variant="secondary"
        size={buttonSize}
        className={[secondaryClassName, btnClass].filter(Boolean).join(' ')}
        as={Link as any}
        to="/book-a-call"
      >
        <span className={labelClass}>Book a 30 Min Call</span>
        <SbrIcon icon={LuArrowRight} className={iconClass} size={arrowIconSize} />
      </Button>
      <Button
        variant={secondaryVariant}
        size={buttonSize}
        className={[outlineClassName, btnClass].filter(Boolean).join(' ')}
        as={Link as any}
        to={secondary.to}
      >
        {iconAtStart ? <SbrIcon icon={SecondaryIcon} className={iconClass} size={secondaryIconSize} /> : null}
        {secondaryLabel}
        {!iconAtStart ? <SbrIcon icon={SecondaryIcon} className={iconClass} size={secondaryIconSize} /> : null}
      </Button>
    </>
  );
}
